import styled from "styled-components";

export const ContentTabList = styled.ul`
  display: flex;
  align-items: center;
  gap: 4px;
`;
